if(!customElements.get('content-spot')) {
  customElements.define('content-spot', 
    class ContentSpot extends HTMLElement {
      constructor() {
        super();
        this.media = this.querySelector('[data-media]');
        this.productCard = this.nextElementSibling || this.previousElementSibling;
        if(!this.media && !this.productCard.classList.contains('product-card')) return;

        this.calculateHeight();
        this.handleVideoPlay();
      }

      get sizeMobile() {
        return Number(this.dataset.sizeMobile);
      }

      get columsDesktop() {
        return Number(this.dataset.colunmsDesktop);
      }

      get rowsDesktop() {
         return Number(this.dataset.rowsDesktop);
      }

      calculateHeight() {
        const productCardMediaHeight = this.productCard.querySelector('img')?.clientHeight;
        if(!productCardMediaHeight) return;
        if(window.innerWidth < 990) {
          if(this.sizeMobile > 1) return;
           this.media.style.maxHeight = `${productCardMediaHeight}px`;
        } else {
          if(this.rowsDesktop === 1 && this.columsDesktop < 4) {
           this.media.style.maxHeight = `${productCardMediaHeight}px`;
          }
        }
      }

      handleVideoPlay() {
        const videos = this.querySelectorAll('video');
        if(videos.length === 0) return;
        
        if(videos.length === 1) {
          this.observVideo(videos[0]);
        } else {
          const matchesBreakpoint = (video) => (
            (window.innerWidth >= 990 && video.classList.contains('video-desktop')) ||
            ( window.innerWidth < 990 && video.classList.contains('video-mobile'))
          );
          videos.forEach((video) => {
            if (matchesBreakpoint(video)) {
              this.observVideo(video);
            }
          });
        }
      }

      observVideo(video) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if(entry.isIntersecting) {
              video.play();
            } else {
              video.pause();
            }
          })
        }, {
          threshold: 0.5
        });
        observer.observe(video);
      }
    }
  )
}